import { createLogger } from 'shared/services/logger';
import us from '../../defines';
import {env} from '../../lib/utility/browser-compatibility';

const logger = createLogger('UScope:extensions:Thumbnail:HeatMapOverlay');

//    improvements:
//    - perhaps alpha is set according to the view mag so smaller views are easier to distinguish
//    - browser resize clears the heatmap even when it is not resized for unknown reasons

export function ThumbnailHeatMapOverlay (uScope, viewport, userConfig, thumbnailControl) {
  var self = this;
  let isVisible = true;
  var jThumbDiv = thumbnailControl.$container;
  var isLoaded = false; // heatmap has been loaded

  var jHeatMap;
  var heatMapId; // heatmap canvas tag id
  var pHMCanvas; // canvas
  var pHMContext; // context

  // 0.08 seems to strike a good balance between not obscuring the view for small-increment updates (e.g. viewport pans)
  // and still being visible when panning using larger increments (e.g. raster scan or thumbnail pans). Note this relies
  // on opacity css on the canvas element
  const DEFAULT_ALPHA = 0.08;

  // ............................................ resize() public
  this.resize = function () {
    if (isLoaded == false) return;
    // Note: resetting because browser resize does not retain heatmap
    if (pHMContext) {
      if (pHMCanvas.width == jThumbDiv.width() && pHMCanvas.height == jThumbDiv.height()) { return; }

      var data = pHMCanvas.toDataURL(); // save the canvas content as imageURL

      pHMCanvas.width = jThumbDiv.width(); // resize the canvas which clears its context
      pHMCanvas.height = jThumbDiv.height();

      var self = this; // save the local context for use in onload callback
      var img = new Image(); // scale and redraw the canvas content

      // Wait for image to load. In some circumstances, the image may not be ready immediately
      // use img.onload (all lowercase) or img.addEventListener('load', function () {}), not img.onLoad !!! Case matters!
      img.onload = function () {
        pHMContext.drawImage(img, 0, 0, img.width, img.height, 0, 0, pHMCanvas.width, pHMCanvas.height);
        self.contextDefault(); // restore the cleared canvas context to its default values
      };

      img.onerror = function (err) {
        logger.error('cThumbHeatMap: resize: loading image at ' + img.src, err);
      };

      img.src = data; // start loading the image
    }
  };

  // ............................................ settings fns public
  this.alphaSet = function (alpha) {
    if (pHMContext) {
      pHMContext.globalAlpha = alpha;
    }
  }; // s/b between 0 and 1.0
  this.fillColorSet = function (color) {
    if (pHMContext) pHMContext.fillStyle = color;
  };
  this.fillColorGet = function () {
    return (pHMContext) ? pHMContext.fillStyle : '#000000';
  };
  this.strokeColorSet = function (color) {
    if (pHMContext) pHMContext.strokeStyle = color;
  };
  this.strokeColorGet = function () {
    return (pHMContext) ? pHMContext.strokeStyle : '#000000';
  };

  // ............................................ contextDefault() public
  this.contextDefault = function () {
    if (!isLoaded) {
      return;
    }
    if (pHMContext) {
      this.alphaSet(DEFAULT_ALPHA);
      var color = us.objectiveColor(viewport.getViewMag());
      this.fillColorSet(color);
      this.strokeColorSet(color);

      pHMContext.globalCompositeOperation = 'source-over';
    }
  };
  // ............................................ rectFill() public
  this.rectFill = function (x, y, w, h, opt_alpha, opt_color) {
    if (!isVisible || !isLoaded || !pHMContext) {
      return;
    }
    pHMContext.save();
    pHMContext.beginPath();

    if (opt_alpha) this.alphaSet(opt_alpha);
    if (opt_color) this.fillColorSet(opt_color);
    pHMContext.rect(x, y, w, h);
    pHMContext.fill();

    pHMContext.restore();
  };
  // ............................................ drawRect() public
  this.drawRect = function (x, y, w, h, opt_alpha, opt_color) {
    if (isVisible == false) return; // live switch
    if (isLoaded == false) return;
    if (pHMContext) {
      pHMContext.save();

      pHMContext.beginPath();
      if (opt_alpha) {
        this.alphaSet(opt_alpha);
      }
      // why not             pHMContext.globalAlpha = 0.2;
      if (opt_color) {
        this.strokeColorSet(opt_color);
      }

      pHMContext.rect(x, y, w, h);
      pHMContext.stroke();

      pHMContext.restore();
    }
  };
  // ............................................ drawPixels() public
  this.drawPixels = function (pixelList, hexColor, opt_doDouble) {
    if (isVisible == false) return; // live switch
    if (isLoaded == false) return;
    if (pHMContext) {
      var color = parseInt(hexColor.substr(1), 16);
      var blue = (color & 0xFF);
      var green = (color >> 8) & 0xFF;
      var red = (color >> 16) & 0xFF;

      var canvasWidth = pHMCanvas.width;
      var canvasData = pHMContext.getImageData(0, 0, canvasWidth, pHMCanvas.height);

      for (var i = 0, len = pixelList.length; i < len; i++) {
        var pt = pixelList[i];
        var index = (pt.x + pt.y * canvasWidth) * 4;

        canvasData.data[index] = red;
        canvasData.data[index + 1] = green;
        canvasData.data[index + 2] = blue;
        canvasData.data[index + 3] = 255; // important to set alpha

        if (opt_doDouble == true) { // if parms says to double the pt
          index += 4;
          canvasData.data[index] = red;
          canvasData.data[index + 1] = green;
          canvasData.data[index + 2] = blue;
          canvasData.data[index + 3] = 255; // important to set alpha
          index += canvasWidth * 4;
          canvasData.data[index] = red;
          canvasData.data[index + 1] = green;
          canvasData.data[index + 2] = blue;
          canvasData.data[index + 3] = 255; // important to set alpha
          index -= 4;
          canvasData.data[index] = red;
          canvasData.data[index + 1] = green;
          canvasData.data[index + 2] = blue;
          canvasData.data[index + 3] = 255; // important to set alpha
        }
      }

      pHMContext.putImageData(canvasData, 0, 0);
    }
  };
  // ............................................ erase() public
  this.erase = function () {
    if (isLoaded == false) return;
    if (pHMContext) pHMContext.clearRect(0, 0, pHMCanvas.width, pHMCanvas.height);
  };

  // ............................................ construct_()
  function construct_ () {
    if (uScope.isThisImageIdValid(viewport.getImageId()) == false) { // protect against rapid slide changes that closes images
      logger.error('heatmap: construct_: image is not loaded');
      isVisible = false;
      return;
    }

    var vpclassid = us.classFromImageId(viewport.getImageId()); // convert the imageId into a class name
    heatMapId = us.CVSHEATMAP + '_' + vpclassid;

    jHeatMap = $('<canvas/>', {'id': heatMapId, 'class': us.CVSHEATMAP + ' ' + us.clsOVERLAY});
    jThumbDiv.append(jHeatMap); // and add it to the thumbnail div
    jHeatMap = jThumbDiv.find('#' + heatMapId);

    pHMCanvas = document.getElementById(heatMapId);
    if (pHMCanvas == undefined || pHMCanvas == null) { // protect against rapid slide close/open sequence that removes elements
      logger.error('heatmap: load: image canvas is not present: ' + heatMapId);
      return;
    }
    pHMContext = pHMCanvas.getContext('2d');

    isLoaded = true;

    pHMCanvas.width = jThumbDiv.width(); // set canvas dims
    pHMCanvas.height = jThumbDiv.height();
    self.contextDefault(); // context default settings

    bindEvents_(); // add event handlers
    // note! this cures a race condition: because of late load of hm, us.evUSERPREFSREADY has already been fired, so get the user pref now
    isVisible = userConfig.get(us.CVSHEATMAP);
  }

  // bindEvents_ - This function adds the heatmap event handlers.
  //
  //    Note that by using the same namespace as the viewport when the
  //    viewport removes its events by namespace, these are also removed.
  function bindEvents_ () {
    var namespace = viewport.eventNameSpaceGet();
    thumbnailControl.events.on('thumbnail:resize', () => {
      self.resize();
    });

    const {position, size} = thumbnailControl.getState();

    $(us.idHashROOT).on(us.evHEATMAPCLEAR + namespace, self.erase); // TODO: swap this out

    // Update the thumbnail on paint
    // It feels odd "adding a layer" to the viewport here, because we're not. This overlay is on top of the
    // thumbnail; TODO maybe the thumbnail needs a "renderer" too.
    viewport.renderer.addLayer({
      paint () {
        // if thisImage is a control unless it is raster scanning, do not draw on the heatmap
        if (viewport.sampleTypeIsControl() && viewport.navModeGet() !== us.eNavModes.nmRasterScan) {
          return;
        }

        // highlights the current view on the heat map
        if (!viewport.isFitZoom()) {
          let left = position.x;
          let top = position.y;
          let width = size.w;
          let height = size.h;

          if (env.isIE) {
            // px adjustments b/c of border&outline
            self.rectFill(left - 2, top - 2, width + 4, height + 4);
          } else { // TODO: do away with browser targeting
            // px adjustments b/c of border&outline
            self.rectFill(left + 2, top + 2, width, height);
          }
        }
      },
      // if this image's zoom changed, then change the overlay color
      zoomChange () {
        var color = us.objectiveColor(viewport.getViewMag());
        self.fillColorSet(color);
      }
    });

    // user preference update
    $(us.idHashROOT).on(us.evUSERPREFSREADY + namespace, function (e, parms) {
      isVisible = userConfig.get(us.CVSHEATMAP);
    });
    $(us.idHashROOT).on(us.evUSERPREFSET + namespace, function (e, parms) { // parms: {className: STR, value: bool}
      if (parms.className == us.CVSHEATMAP) {
        isVisible = parms.value;
      }
    });
  }

  thumbnailControl.events.on('thumbnail:thumbnail-loaded', () => {
    construct_();
  });
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/thumbnail/ThumbnailHeatmapOverlay.js